import { render } from "./Auth.vue?vue&type=template&id=16fa3f07&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=16fa3f07&scoped=true&lang=css"

import exportComponent from "/__w/caption-cafe-web/caption-cafe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fa3f07"]])

export default __exports__